import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';
import {constants} from '../../utils/constants';
import {callTealiumLink} from '../../utils/helpers';
import PropTypes from "prop-types";

class MobileNav extends React.Component {
  constructor(props) {
    super(props);

    this.postalClick = this.postalClick.bind(this);
    this.privacyClick = this.privacyClick.bind(this);
    this.businessClick = this.businessClick.bind(this);
  }

  postalClick(event) {
    callTealiumLink({event_name: 'linkClick', link_category: 'exit', 'link_name': 'Postal' });
  }

  privacyClick(event) {
    callTealiumLink({event_name: 'linkClick', link_category: 'exit', 'link_name': 'Privacy' });
  }

  businessClick () {
    callTealiumLink({event_name: 'linkClick', link_category: 'exit', 'link_name': 'Businesses' });
  }

  render() {
    var classNames = ['navLinksContainer'];

    if (this.props.visible) {
      classNames.push('slideDown');
    } else {
      classNames.push('slideUp');
    }

    return (
      <div className={classNames.join(' ')}>
        <div className='navLinks'>
          <a href={constants.ourBusinessesHref} id='ourBusiness-mobileHeaderLink' onClick={this.businessClick} target='_blank'>{this.translate('ourBusinessLink')}</a>
          <a href={constants.currentPrivacyPolicyHref} id='privacyPolicy-mobileHeaderLink' onClick={this.privacyClick} target='_blank' aria-label="Current Privacy Policy">{this.translate('privacyTitle')}</a>
          <span hidden={this.props.location !== 'US' && this.props.location !== 'CA'}><a href={constants.postalHref} id='postal-headerLink' onClick={this.postalClick} target='_blank'>{this.translate('postalTitle')}</a></span>
        </div>
      </div>
    );
  }
}

MobileNav.propTypes = {
  location: PropTypes.string,
  visible: PropTypes.bool
};

TranslatedComponent(MobileNav);
module.exports = MobileNav;



// WEBPACK FOOTER //
// ./client/src/components/header/MobileNav.jsx